import React, {
  useState
} from "react";

import {
  useDispatch,
  useSelector
} from "react-redux";

import {
  useHistory,
  Link
} from "react-router-dom";

import {
  resetPasswordAction
} from "../../../store/actions/authActions/authActions";
import AuthLayout from "./AuthLayout";

export default function ResetPasswordPageNode() {

  const dispatch =
    useDispatch();

  const history =
    useHistory();

 const verificationId =

  useSelector(
    state =>
      state.auth.verificationId
  )

  ||

  localStorage.getItem(
    "resetVerificationId"
  );

  const [newPassword,
    setNewPassword] =
    useState("");

  const [confirmPassword,
    setConfirmPassword] =
    useState("");

  const [loading,
    setLoading] =
    useState(false);

  const [error,
    setError] =
    useState("");

  const [success,
    setSuccess] =
    useState("");

  /* =========================
     RESET PASSWORD
  ========================= */

  const handleSubmit =
    async e => {

      e.preventDefault();

      setError("");

      setSuccess("");

      if (
        newPassword !==
        confirmPassword
      ) {

        setError(
          "Passwords do not match"
        );

        return;
      }

      try {

        setLoading(true);

       const response = await dispatch(

          resetPasswordAction({

            verificationId,

            newPassword
          })
        );

        console.log(response)
        localStorage.removeItem(
          "pendingReset"
        );

        setSuccess(
          "Password updated successfully"
        );

        setTimeout(() => {

          history.push(
            "/loginV2"
          );

        }, 1500);

      } catch (error) {

        setError(

  error?.message ||

  "Unable to reset password"
);
      } finally {

        setLoading(false);
      }
    };

  return (

    <AuthLayout

  title="Create New Password"

  subtitle="Choose a strong password to secure your account."

>

        <h1>
          Reset Password
        </h1>

        <form
          onSubmit={
            handleSubmit
          }
        >

          <input
            type="password"
            placeholder="New Password"
            value={
              newPassword
            }
            onChange={e =>
              setNewPassword(
                e.target.value
              )
            }
            required
          />
<label>
  New Password
</label>
          <input
            type="password"
            placeholder="Confirm Password"
            value={
              confirmPassword
            }
            onChange={e =>
              setConfirmPassword(
                e.target.value
              )
            }
            required
          />

          {

            error && (

              <div
                className="auth-error"
              >

                {error}

              </div>

            )

          }

          {

            success && (

              <div
                className="auth-success"
              >

                {success}

              </div>

            )

          }

          <button
           className="auth-btn"
            type="submit"
            disabled={
              loading
            }
          >

            {

              loading
                ? "Updating..."
                : "Update Password"

            }

          </button>

        </form>

        <div
          style={{
            marginTop: 20
          }}
        >

          <Link
            to="/loginV2"
          >

            Back To Login

          </Link>

        </div>
</AuthLayout>
  );
}